import type { PluginRegistry } from '@common/plugin-host'
import mediaImageManifest from '@common/plugin-media-image/manifest'
import MediaImage from '@common/plugin-media-image/ui'
import mediaVideoManifest from '@common/plugin-media-video/manifest'
import MediaVideo from '@common/plugin-media-video/ui'
import mediaAudioManifest from '@common/plugin-media-audio/manifest'
import MediaAudio from '@common/plugin-media-audio/ui'
import mediaTextManifest from '@common/plugin-media-text/manifest'
import MediaText from '@common/plugin-media-text/ui'
import mediaBinaryManifest from '@common/plugin-media-binary/manifest'
import MediaBinary from '@common/plugin-media-binary/ui'
import pageManifest from '@common/plugin-page/manifest'
import Page from '@common/plugin-page/ui'
import syllabusManifest from '@common/plugin-syllabus/manifest'
import Syllabus from '@common/plugin-syllabus/ui'
import scopeManifest from '@common/plugin-scope/manifest'
import Scope from '@common/plugin-scope/ui'
import teachScreenManifest from '@common/plugin-teach-screen/manifest'
import TeachScreen from '@common/plugin-teach-screen/ui'
import dashboardManifest from '@common/plugin-dashboard/manifest'
import Dashboard from '@common/plugin-dashboard/ui'
import chartManifest from '@common/plugin-chart/manifest'
import Chart from '@common/plugin-chart/ui'
import datasetManifest from '@common/plugin-dataset/manifest'
import Dataset from '@common/plugin-dataset/ui'
import formManifest from '@common/form/manifest'
import Form from '@common/form/ui'

const plugins = [
  { ...mediaImageManifest, component: MediaImage },
  { ...mediaVideoManifest, component: MediaVideo },
  { ...mediaAudioManifest, component: MediaAudio },
  { ...mediaTextManifest, component: MediaText },
  { ...pageManifest, component: Page },
  { ...syllabusManifest, component: Syllabus },
  { ...scopeManifest, component: Scope },
  { ...teachScreenManifest, component: TeachScreen },
  { ...mediaBinaryManifest, component: MediaBinary },
  { ...dashboardManifest, component: Dashboard },
  { ...chartManifest, component: Chart },
  { ...datasetManifest, component: Dataset },
  { ...formManifest, component: Form },
]

export const assetPluginRegistry: PluginRegistry = Object.fromEntries(plugins.map((plugin) => [plugin.id, plugin]))
